type DatedPaper = { created_at: string | null };

function timestamp(value: string | null): number {
    const parsed = value === null ? NaN : Date.parse(value);
    return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
}

/** Keep undated/malformed cached records after dated results, in stable order. */
export function comparePublicPapersNewestFirst(left: DatedPaper, right: DatedPaper): number {
    const leftTime = timestamp(left.created_at);
    const rightTime = timestamp(right.created_at);
    return leftTime === rightTime ? 0 : rightTime - leftTime;
}
